module.exports = __webpack_public_path__ + "assets/Gitlab.523d5e81.svg";